export const BrandIntroductionModuleName = 'Brand Introduction';
